var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframeDom",attrs:{"name":"iframeChild","id":"iframeChild","src":_vm.pageUrl,"width":"100%","height":"100%","frameborder":"0","scrolling":"no"}})}
var staticRenderFns = []

export { render, staticRenderFns }